import {
  Box,
  ButtonIcon,
  Dropdown,
  ListGroup,
  ListItem,
} from '@cubeyou-team/hx-react-components';
import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { DATA_SOURCE_IDS } from '@discover-frontend/constants';

import { useRepositoryItemContext } from 'src/components/RepositoryItem/providers/RepositoryItemProvider';
import { useAudienceActivationContext } from 'src/modules/audience-activation/providers/AudienceActivationProvider';
import { TRIAL_FEATURES, useTrialPaywall } from 'src/modules/trial-paywall';
import { sendEvent } from '../../../actions';
import { AudienceActivationItemActions } from '../../../modules/audience-activation';

const getRepoItemActions = (item, actions, sendEvent, guardFeature) => {
  const move = (
    <ListItem
      text="Move to"
      iconLeft="move_to"
      onClick={() => {
        actions.move(item);
        sendEvent('Workspace');
      }}
    />
  );

  const rename = (
    <ListItem
      text="Rename"
      iconLeft="text"
      onClick={() => {
        actions.rename(item);
        sendEvent('Workspace');
      }}
    />
  );

  const del = (type) => (
    <ListItem
      text="Delete"
      iconLeft="delete"
      onClick={() => {
        actions.delete([item], type);
        sendEvent('Workspace');
      }}
    />
  );

  const preview = (
    <ListItem
      text="Audience preview"
      iconLeft="show"
      onClick={() => {
        actions.preview(item);
        sendEvent('Workspace');
      }}
    />
  );

  const copy = (
    <ListItem
      text="Make a Copy"
      iconLeft="copy"
      onClick={() => {
        actions.clone(item);
        sendEvent('Workspace');
      }}
    />
  );

  const edit = (isDisabled) => (
    <ListItem
      text="Edit audience"
      iconLeft="edit"
      onClick={() => {
        actions.edit(item);
        sendEvent('Workspace');
      }}
      isDisabled={isDisabled}
    />
  );

  const save = (
    <ListItem
      text="Save"
      iconLeft="star_outline"
      onClick={() => {
        actions.save(item);
        sendEvent('Workspace');
      }}
    />
  );

  const share = (
    <ListItem
      text="Share"
      iconLeft="share"
      isDisabled={item.metadata?.data_source === DATA_SOURCE_IDS.BROWSER}
      onClick={() => {
        guardFeature(TRIAL_FEATURES.SHARE, () => {
          actions.share(item);
          sendEvent('Workspace');
        });
      }}
    />
  );

  const queryType = item.metadata ? item.metadata.query_type : undefined;

  if (item.type === 'folder') {
    return [move, rename, del('folder')];
  }

  if (item.type === 'audience') {
    if (item.access === 'public') {
      return [preview, copy];
    }
    if (item.access === 'private') {
      if (item.persistence === 'temporary') {
        if (['tsv', 'conversation'].includes(queryType)) {
          if (item.metadata.status === 'ready') {
            return [
              preview,
              edit(queryType === 'tsv'),
              save,
              share,
              del('audience'),
            ];
          }
          return [preview];
        }
        return [
          preview,
          edit(queryType === 'segmentation'),
          save,
          share,
          del('audience'),
        ];
      } else {
        return [
          preview,
          edit(queryType === 'segmentation'),
          copy,
          rename,
          move,
          del('audience'),
          share,
        ];
      }
    }
  }

  return [];
};

const RepositoryItemMoreActions = ({
  item,
  show,
  onMoreActionClick,
  actions,
  sendEvent,
}) => {
  const containerRef = useRef();
  const [dropDownPosition, SetDropDownPosition] = useState('left');
  const { onOpenDeleteCampaignModal } = useRepositoryItemContext();
  const { openModal, setRepositoryItem } = useAudienceActivationContext();
  const { guardFeature } = useTrialPaywall();

  useLayoutEffect(() => {
    if (containerRef.current) {
      if (
        containerRef.current.getBoundingClientRect().y >
        window.innerHeight * 0.8
      ) {
        SetDropDownPosition('top-left');
      }
    }
  }, [show]);

  const onClickOutside = useCallback(
    () => onMoreActionClick(false),
    [onMoreActionClick]
  );

  const audienceActivationItemActions = new AudienceActivationItemActions(
    item,
    actions,
    sendEvent,
    openModal,
    setRepositoryItem
  );

  const repoItemActions = item?.campaign
    ? audienceActivationItemActions.getActions(onOpenDeleteCampaignModal)
    : getRepoItemActions(item, actions, sendEvent, guardFeature);

  return (
    <>
      <div ref={containerRef}>
        <Dropdown
          isOpen={show}
          position={dropDownPosition}
          content={
            <Box pX="small" pT="small">
              <ListGroup items={repoItemActions} />
            </Box>
          }
          onClickOutside={onClickOutside}
        >
          <ButtonIcon
            size="small"
            icon="more"
            className="hx-repository-item__more-actions"
            data-test="action-open"
            onClick={(e) => {
              e.stopPropagation();
              onMoreActionClick(true);
            }}
          />
        </Dropdown>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  sendEvent,
};

export default connect(null, mapDispatchToProps)(RepositoryItemMoreActions);
